export default {
  Asset: "Tài sản",
  AssetCode: "Mã tài sản ",
  AssetName: "Tên tài sản",
  Quantity: "Số lượng",
  Unit: "Đơn vị tính",
  OrgPrice: "Đơn giá",
  OrgAmount: "Thành tiền",
  SerialNumber: "Số serial",
  Specification: "Quy cách tài sản",
  AssetRoot: "Nguồn gốc",
  ContractNumber: "Số hợp đồng",
  IsPermanentAsset: "Là tài sản cố định",
  WarrantyTime: "Thời gian bảo hành",
  WarrantyUnit: "Đơn vị tính thời gian bảo hành",
  WarrantyPeriod: "Hạn bảo hành",
  WarrantyCondition: "Điều kiện bảo hành",
  MaintenanceTime: "Kỳ bảo dưỡng",
  MaintenanceUnit: "Đơn vị tính kỳ bảo dưỡng",
  MaintenanceBegin: "Bắt đầu bảo dưỡng từ",
  AllocationType: "Đã cấp phát cho",
  EmployeeCode: "Nhân viên",
  // EmployeeCode_0: "Nhân viên",
  AllocationDate: "Ngày cấp phát",
  AssetTypeID: "Loại tài sản",
  AssetTypeName: "Loại tài sản",
  OrganizationUnitName: "Đơn vị quản lý",
  OrganizationUnitID: "Đơn vị quản lý",
  OrganizationUnitCode: "Đơn vị quản lý",
  OrganizationUnitTypeID: "Cấp tổ chức",
  ShortCutName: "Tên viết tắt",
  AssetStatusID: "Tình trạng",
  AssetStatusName: "Tình trạng",
  EmployeeName: "Người sử dụng",
  PurchaseDate: "Ngày mua",
  IsFixedAsset: "Là tài sản cố định",
  AssetList: {
    // AssetName: "ABC"
  },
  // người dùng
  UserPermission: {
    UserName: "Mã nhân viên",
    FullName: "Họ và tên",
    OrganizationUnitName: "Đơn vị công tác",
    JobPositionName: "Vị trí công việc",
    Email: "Email",
    Phone: "Số điện thoại",
    AssetStatusName: "Tình trạng",
  },

  /*
  NCC
  */
  AccountObjectCode: "Mã NCC",
  AccountObjectName: "Tên NCC",
  AccountObjectGroupID: "Nhóm NCC",
  AccountObjectGroupName: "Nhóm NCC",
  Address: "Địa chỉ",
  TaxCode: "Mã số thuế",
  Tel: "Điện thoại",
  Fax: "Fax",
  Email: "Email",
  Website: "Website",
  BankAccount: "Tài khoản ngân hàng",
  BankName: "Mở tại",
  Description: "Ghi chú",
  Prefix: "Xưng hô",
  ContactName: "Họ và tên (người liên hệ)",
  ContactTitle: "Chức danh (người liên hệ)",
  ContactHomePhone: "ĐT nhà riêng (người liên hệ)",
  ContactMobile: "ĐT di động (người liên hệ)",
  ContactTel: "ĐT cơ quan (người liên hệ)",
  ContactEmail: "Email (người liên hệ)",
  ContactAddress: "Địa chỉ (người liên hệ)",
  IdentificationNumber: "Số CMND/TCC (người liên hệ)",
  IssueDate: "Ngày cấp (người liên hệ)",
  IssueBy: "Nơi cấp (người liên hệ)",
  LocationName: "Tên vị trí tài sản",
  LocationCode: "Mã vị trí tài sản",
  ParentID: "Thuộc",
  AssetTypeCode: "Mã loại tài sản",
  AssetCategoryCode: "Mã nhóm tài sản",
  AssetCategoryName: "Thuộc nhóm tài sản",
  AssetCategoryID: "Nhóm tài sản",
  IsByQuantity: "Cách quản lý",
  IsTrackWarranty: "Bảo hành",
  IsMaintenance: "Bảo dưỡng",
  Import: {
    //Không được đặt tên cột trùng nhau để tránh mapping nhầm
    // AssetName: "Cột tên tài sản"
    AssetTypeName: "Tên loại tài sản",
    AssetCategoryName: "Tên nhóm tài sản",
    ParentCode: "Thuộc",
    ParentLocationCode: "Thuộc",
    ParentAssetCategoryCode: "Thuộc nhóm",
    OrganizationUnitName: "Đơn vị quản lý",
    ParentName: "Thuộc đơn vị",
    AssetTypeCode: "Loại tài sản",
    LocationCode: "Mã vị trí tài sản",
    OrganizationUnitCode: "Phòng ban",
    ManagementUnitCode: "Đơn vị quản lý",
    ManagerCode: "Người quản lý",
    RepresentativeCode: "Người đại diện",
    //Các trường lưu thông tin khấu hao/phân bổ của tài sản
    DepreciationAmount: "Giá trị tính khấu hao/phân bổ",
    LifeTime: "Thời gian khấu hao/phân bổ",
    LifeTimeUnit: "Đơn vị tính thời gian khấu hao/ phân bổ",
    DepreciationDate: "Ngày bắt đầu khấu hao/phân bổ",
    LifeTimeRemaining: "Thời gian còn lại",
    AccumDepreciationAmount: "Khấu hao/phân bổ lũy kế",
    RemainingAmount: "Giá trị còn lại",
    CustomerCode: "Mã khách hàng",
    CustomerName: "Tên khách hàng",
    CustomerPhone: "Số điện thoại khách hàng",
    CustomerEmail: "Email khách hàng",
    CustomerAddress: "Địa chỉ khách hàng",
    Amount: "Số tiền",
    DueDate: "Hạn thanh toán",
    Description: "Nội dung",
  },
  // quá trình sử dụng
  IncreaseQuantity: "Số lượng tăng thêm",
  UsageHistory: {
    AssetCode: "Mã tài sản ",
    AssetName: "Tên tài sản",
    IncreaseQuantity: "Số lượng tăng thêm",
  },
};
